
<script setup>
import { ref, defineProps, getCurrentInstance, onMounted, defineEmits } from "vue";
import { useCreateCart, useCreateB2BCart } from '@/hooks/shopify-hooks/useManageCart';
import { isEnableShopify, shopifyConst } from "@/hooks/shopify-hooks/useShopifyConst";
import { _CSR_ACCESS_TOKEN, _CSR_IS_B2b, _CSP_STORENFONT_TOKEN, _CSR_COMPANY_LOCATION, _CSR_LOGIN_EMAIL } from '@/const/shopifyConst';
import useProductApi from '@/hooks/shopify-hooks/api/useProductApi';
import { useCustomer } from '@/hooks/shopify-hooks/useCustomer';
import { useMultipassCheckoutUrl, useIsAccessTokenValid } from '@/hooks/shopify-hooks/useShopifyUtils';
import { useDeleteLoginStorage } from "@/hooks/shopify-hooks/useShopifyMessageEvent";
import { useProductAttributes, useHandleAttributes } from '@/hooks/common/useProductAttributes';
import { useGetStorage } from '@/hooks/common/useStorage';
import { updateCustomerCartBuyerIdentity, updateCartBuyerIdentity } from '@/hooks/shopify-hooks/api/useLoginApi';
const { checkOutButtonSoldOutNotice , c4aOAuth2State} = shopifyConst;
const { proxy } = getCurrentInstance();
const $emit = defineEmits(["hide"]);
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;

const props = defineProps({
    stateKey: {
		type: String,
		default: ''
	},
	skuInfo: {
		type: Object,
		default: () => {
			return {};
		}
	},
	dataset: {
		type: Object,
		default: () => {
		return {};
		},
	},
	label: {
		type: String,
		default: ""
	},
	shopifyVariant: {
		type: [Object, String],
		default: "",
	},
});
const isB2b = c4aOAuth2StateNew ? c4aOAuth2StateNew : useGetStorage(_CSR_IS_B2b);

const { product: { productModelNumber = '', mainImage, firstImage, link }, variantsName, variantsType, variantsTitle } = proxy?.skuInfo || {};

const webUrl = ref('');
const isShow= ref(false);
const isDisabled = ref(true);
const lineItem = ref({});
const soldOutNotice = ref(checkOutButtonSoldOutNotice); // 无库存的按钮文案
const cartId = ref('');

// 拿到shopify的数据，从父级传递过来or通过调用接口
const fetchShopifyData = (sku) =>{
  return new Promise((resolve, reject) =>{
    if(props.shopifyVariant){
    	resolve(props.shopifyVariant);
    }else{
		useProductApi(sku).then(async (res) => {
			resolve(res.data.product?.variants?.nodes[0]??"");
		}).catch(() =>{
			reject("");
		});
	}
  });
};

onMounted(async () => {
	console.log('--------------测试222isEnableShopify',isEnableShopify)
	if (!isEnableShopify) {
		isShow.value = false;
		return;
	} else {
		isShow.value = true;
		queryProduct();
	}
})

const queryProduct = async () => {
	try {
			const detail = await fetchShopifyData(productModelNumber);
			console.log('--------------测试222detail',detail)
			if (!detail || Object.keys(detail)?.length === 0) {
				// 查不到商品，直接隐藏按钮
				isShow.value = false;
				$emit("hide");
				return;
			}
			// 库存为0时，不显示加入购物车按钮
			if (detail.quantityAvailable === 0 || !detail.availableForSale) {
				isDisabled.value = true;
				return;
			} else {
				const attributes = useProductAttributes({ variantsName, variantsType, variantsTitle });
				// my order要用到
				const productAttributes = [{
						key: '_productImage',
						value: mainImage || firstImage,
					}, {
						key: '_productLink',
						value: link.indexOf('?wcmmode') > -1 ? location.origin + link.split('?wcmmode')[0] : location.origin + link,
					}];
				const lineAttributes = productAttributes.concat(attributes);
				// 去掉空value的参数
				const finalAttributes = useHandleAttributes(lineAttributes);
				lineItem.value = {
					lines: [
						{
							"quantity": 1,
							"merchandiseId": detail.id,
							"attributes": finalAttributes
						}
					],
					attributes: {
						key: 'cartOrigin',
						value: 'checkout'
					}
				}
				isDisabled.value = false;
			}
		} catch(e) {
			isDisabled.value = true;
		}
}

const handleChectout = async () => {
	try {
		const cartInput = lineItem.value;
		let res = '';
		if (isB2b) {
			
			// const storefrontToken = localStorage.getItem(_CSP_STORENFONT_TOKEN);
			// const locationId = localStorage.getItem(_CSR_COMPANY_LOCATION);
			const storefrontToken = useGetStorage(_CSP_STORENFONT_TOKEN);
			const locationId = useGetStorage(_CSR_COMPANY_LOCATION);
			const buyerIdentity = {
					customerAccessToken: storefrontToken,
					companyLocationId: locationId
			};
			// 有公司ID, 才创建b2b购物车
			if (locationId) {
				res = await useCreateB2BCart(cartInput, buyerIdentity);
			} else {
				res = await useCreateCart(cartInput);
			}
		} else {
			res = await useCreateCart(cartInput);
		}
		if (res?.cartCreate?.cart?.checkoutUrl) {
			cartId.value = res?.cartCreate?.cart?.id;
			if(c4aOAuth2StateNew) {
			const storefrontToken = useGetStorage(_CSP_STORENFONT_TOKEN);
			const b2bBuyerIdentity = {
					customerAccessToken: storefrontToken,
				};
				await updateCartBuyerIdentity(b2bBuyerIdentity, cartId.value);
			}
			webUrl.value = res.cartCreate.cart.checkoutUrl;
			checkOut()
		}
	} catch(e) {
		console.error(e);
	}
}

const checkOut = async () => {
    if (webUrl.value) {
			if (isB2b) {
				// 带上token, checkout才能带上用户信息
				const customerAccessToken = useGetStorage(_CSP_STORENFONT_TOKEN);
				window.location.href = handleUrlRemoveChannel(webUrl.value) + '&token=' + encodeURIComponent(customerAccessToken);
			} else {
				if (useIsAccessTokenValid()) {
					// 更新购物车登录信息
                    const res = await resetUpdateCustomerCartBuyerIdentity();
					if (res?.cartBuyerIdentityUpdate?.cart?.checkoutUrl) {
						webUrl.value = res?.cartBuyerIdentityUpdate?.cart?.checkoutUrl;
						console.log('--更新webUrl.value', webUrl.value);
						// 若已登录用户，包装一层checkout url, 目的是把登录态,用户信息,地址带过去给shopify
						wrapCheckoutUrl()
					}
					
				} else {
					// 非登录用户，直接跳
					window.location.href = handleUrlRemoveChannel(webUrl.value);
				}
				
				// 加密功能需要额外付钱的，墨西哥站点不支持
				// window.location.href = webUrl.value;
			}
    }
}

// 更新购物车登录信息
const resetUpdateCustomerCartBuyerIdentity = async () => {
	const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
	const access_token = accessToken?.accessToken;
	const email =  useGetStorage(_CSR_LOGIN_EMAIL);
	const buyerIdentity = {
        customerAccessToken: access_token,
        email: email
    }
	const data = await updateCustomerCartBuyerIdentity(buyerIdentity, cartId.value);
	return data;
	
}

const wrapCheckoutUrl = async () => {
	const { domain, countryIsoCode } = shopifyConst;
	const { getCustomer } = useCustomer();
	const customer = await getCustomer();
	// 若当前用户失效(出现在多人同登一个账号的情况，其中一人退出登录)，则直接跳
	if (!customer) {
		await useDeleteLoginStorage();
		window.location.href = handleUrlRemoveChannel(webUrl.value);
		return;
	}
	// const accessToken = JSON.parse(localStorage.getItem(_CSR_ACCESS_TOKEN));
	const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
	const access_token = accessToken?.accessToken;
	const checkoutUrl = handleUrlRemoveChannel(webUrl.value);
	const date = new Date().toISOString();

	const postData = JSON.stringify({
			"email": customer.email,
			"created_at": date,
			"first_name": customer.firstName,
			"last_name": customer.lastName,
			"return_to": checkoutUrl,
			"addresses": customer?.addresses?.edges?.length ? customer.addresses.edges.map(({ node: address }) => {
					return {
					"address1": address.address1,
					"address2": address.address2,
					"city": address.city,
					"country": address.country,
					"first_name": address.firstName,
					"last_name": address.lastName,
					"phone": address.phone,
					"province": address.province,
					"zip": address.zip,
					"province_code": address.provinceCode,
					"country_code": countryIsoCode,
					"default": (address.id === customer?.defaultAddress?.id)
					}
			}) : []
		});
	const response = await useMultipassCheckoutUrl(access_token, postData);
	if (response && response.token) {
		window.location.href = 'https://' + domain + '/account/login/multipass/' + encodeURIComponent(response.token);
	} else if (response.value === 'ISC-924') {
		// 墨西哥若接口返回报错ISC-924，去掉channel, 直接跳
		window.location.href = handleUrlRemoveChannel(webUrl.value);
	}
}

const handleUrlRemoveChannel = (url) => {
	const [base, query] = url.split('?');
	const params = new URLSearchParams(query);
	params.delete('channel');
	const cleanedUrl = base + (params.toString() ? '?' + params.toString() : '');
	return cleanedUrl;
}

</script>

<template>
  <div class="csr-cp-checkout" v-if="isShow">
		<a href="javascript:void(0)" :class="['csr-cp-checkout_btn', dataset.className]" @click="handleChectout" :disabled="isDisabled">{{ isDisabled ? soldOutNotice || dataset.buttonLabel : dataset.buttonLabel || label }}</a>
  </div>
</template>

<style scoped lang="less">
</style>